export default function FooterBar() {
  return (
    <footer className="bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/9ed2ffaa-9a18-4b65-82e1-771deaf8a334.png"
            alt="AMIK P.C. Logo"
            className="h-7 w-auto object-contain"
          />
          <span className="text-white font-bold tracking-widest text-sm">AMIK P.C.</span>
        </div>
        <p className="text-gray-500 text-xs text-center">
          &copy; {new Date().getFullYear()} AMIK P.C. All rights reserved. &nbsp;|&nbsp; Agioi Anargyroi, Greece
        </p>
        <div className="flex items-center gap-4">
          <span className="text-gray-500 text-xs">info@amikpc.com</span>
        </div>
      </div>
    </footer>
  );
}
